import(/* webpackMode: "eager" */ "/workspace/src/app/[locale]/(auth)/layout.tsx");
